import type { GlobalCopilotEntrypoint } from '../../telemetry/types';

import { useCloseGlobalCopilot } from './closeGlobalCopilot';
import { useGlobalCopilotContextStore } from './globalCopilotContextStore';
import { enableGlobalCopilot, useGlobalCopilotStore } from './globalCopilotStore';
import { useOfficeAICopilotStore } from './officeAICopilotStore';
import { useOpenGlobalCopilot } from './openGlobalCopilot';
import type { GlobalCopilotContext } from './types';

export { enableGlobalCopilot, useCloseGlobalCopilot, useOpenGlobalCopilot };

export const useIsGlobalCopilotEnabled = (): boolean => useGlobalCopilotStore((state) => state.isEnabled);

export const useIsGlobalCopilotOpen = (): boolean => useGlobalCopilotStore((state) => state.isOpen);

export const useHasGlobalCopilotOpened = (): boolean => useGlobalCopilotStore((state) => state.hasOpened);

export const getIsGlobalCopilotOpen = (): boolean => useGlobalCopilotStore.getState().isOpen;

export const useGlobalCopilotSessionId = (): string => useGlobalCopilotStore((state) => state.sessionId);

export const getGlobalCopilotSessionId = (): string => useGlobalCopilotStore.getState().sessionId;

export const getGlobalCopilotEntrypoint = (): GlobalCopilotEntrypoint | undefined =>
  useGlobalCopilotStore.getState().entrypoint;

export const openGlobalCopilotDrawer = (entrypoint: GlobalCopilotEntrypoint): void => {
  useGlobalCopilotStore.getState().openDrawer(entrypoint);
};

export const prepareGlobalCopilotSession = (): void => {
  useGlobalCopilotStore.getState().prepareSession();
};

export const resetGlobalCopilotHostMount = (): void => {
  useGlobalCopilotStore.getState().resetHostMount();
};

export const useIsGlobalCopilotHistoryButtonDisabled = (): boolean =>
  useOfficeAICopilotStore((state) => state.isHistoryButtonDisabled);

export const useSetGlobalCopilotHistoryButtonDisabled = (): ((isHistoryButtonDisabled: boolean) => void) =>
  useOfficeAICopilotStore((state) => state.setIsHistoryButtonDisabled);

export const useGlobalCopilotContextData = (): GlobalCopilotContext | null =>
  useGlobalCopilotContextStore((state) => state.sessionOperationContextData);

export const useIsUsingGlobalCopilotContext = (): boolean =>
  useGlobalCopilotContextStore((state) => state.isUsingContext);

export const useReplaceGlobalCopilotContext = (): ((context: GlobalCopilotContext) => void) =>
  useGlobalCopilotContextStore((state) => state.replaceSessionOperationContextData);

export const useClearGlobalCopilotContext = (): (() => void) =>
  useGlobalCopilotContextStore((state) => state.clearSessionOperationContextData);

export const useSetIsUsingGlobalCopilotContext = (): ((isUsingContext: boolean) => void) =>
  useGlobalCopilotContextStore((state) => state.setIsUsingContext);

export const replaceGlobalCopilotContext = (context: GlobalCopilotContext): void => {
  useGlobalCopilotContextStore.getState().replaceSessionOperationContextData(context);
};
